// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/workflow.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelWorkflowExecutionActionRequest, CancelWorkflowExecutionActionResponse, CancelWorkflowExecutionRequest, CancelWorkflowExecutionResponse, CreateWorkflowRequest, CreateWorkflowResponse, DeleteWorkflowRequest, DeleteWorkflowResponse, GetWorkflowExecutionActionRequest, GetWorkflowExecutionActionResponse, GetWorkflowExecutionRequest, GetWorkflowExecutionResponse, GetWorkflowRequest, GetWorkflowResponse, GetWorkflowWebhookSecretRequest, GetWorkflowWebhookSecretResponse, ListWorkflowExecutionActionsRequest, ListWorkflowExecutionActionsResponse, ListWorkflowExecutionsRequest, ListWorkflowExecutionsResponse, ListWorkflowsRequest, ListWorkflowsResponse, RotateWorkflowWebhookSecretRequest, RotateWorkflowWebhookSecretResponse, StartWorkflowRequest, StartWorkflowResponse, UpdateWorkflowRequest, UpdateWorkflowResponse } from "./workflow_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.WorkflowService
 */
export const WorkflowService = {
  typeName: "gitpod.v1.WorkflowService",
  methods: {
    /**
     * Creates a new workflow with specified configuration.
     *
     * Use this method to:
     * - Set up automated workflows
     * - Configure workflow triggers
     * - Define workflow actions and steps
     * - Set execution limits and constraints
     *
     * @generated from rpc gitpod.v1.WorkflowService.CreateWorkflow
     */
    createWorkflow: {
      name: "CreateWorkflow",
      I: CreateWorkflowRequest,
      O: CreateWorkflowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific workflow.
     *
     * Use this method to:
     * - View workflow configuration
     * - Check workflow status
     * - Get workflow metadata
     *
     * ### Examples
     *
     * - Get workflow details:
     *
     *   Retrieves information about a specific workflow.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.GetWorkflow
     */
    getWorkflow: {
      name: "GetWorkflow",
      I: GetWorkflowRequest,
      O: GetWorkflowResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a workflow's configuration using full replacement semantics.
     *
     * Update Behavior:
     * - All provided fields completely replace existing values
     * - Optional fields that are not provided remain unchanged
     * - Complex fields (triggers, action) are replaced entirely, not merged
     * - To remove optional fields, explicitly set them to empty/default values
     *
     * Use this method to:
     * - Modify workflow settings
     * - Update triggers and actions
     * - Change execution limits
     * - Update workflow steps
     *
     * ### Examples
     *
     * - Update workflow name:
     *
     *   Changes the workflow's display name.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "Updated Workflow Name"
     *   ```
     *
     * - Replace all triggers:
     *
     *   Completely replaces the workflow's trigger configuration.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   triggers:
     *     - manual: {}
     *       context:
     *         projects:
     *           projectIds: ["new-project-id"]
     *   ```
     *
     * - Update execution limits:
     *
     *   Completely replaces the workflow's action configuration.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   action:
     *     limits:
     *       maxParallel: 10
     *       maxTotal: 100
     *     steps:
     *       - task:
     *           command: "npm test"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.UpdateWorkflow
     */
    updateWorkflow: {
      name: "UpdateWorkflow",
      I: UpdateWorkflowRequest,
      O: UpdateWorkflowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.WorkflowService.ListWorkflows
     */
    listWorkflows: {
      name: "ListWorkflows",
      I: ListWorkflowsRequest,
      O: ListWorkflowsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes a workflow permanently.
     *
     * Use this method to:
     * - Remove unused workflows
     * - Clean up test workflows
     * - Delete obsolete configurations
     *
     * ### Examples
     *
     * - Delete workflow:
     *
     *   Permanently removes a workflow.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.DeleteWorkflow
     */
    deleteWorkflow: {
      name: "DeleteWorkflow",
      I: DeleteWorkflowRequest,
      O: DeleteWorkflowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts a workflow execution.
     *
     * Use this method to:
     * - Start workflow execution on demand
     * - Test workflow configurations
     * - Run workflows outside of automatic triggers
     *
     * ### Examples
     *
     * - Start workflow:
     *
     *   Starts a workflow execution manually.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.StartWorkflow
     */
    startWorkflow: {
      name: "StartWorkflow",
      I: StartWorkflowRequest,
      O: StartWorkflowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists workflow executions with optional filtering.
     *
     * Use this method to:
     * - Monitor workflow execution history
     * - Track execution status
     * - Debug workflow issues
     *
     * ### Examples
     *
     * - List executions for workflow:
     *
     *   Shows all executions for a specific workflow.
     *
     *   ```yaml
     *   filter:
     *     workflowIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.ListWorkflowExecutions
     */
    listWorkflowExecutions: {
      name: "ListWorkflowExecutions",
      I: ListWorkflowExecutionsRequest,
      O: ListWorkflowExecutionsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific workflow execution.
     *
     * Use this method to:
     * - Check execution status
     * - View execution results
     * - Monitor execution progress
     *
     * ### Examples
     *
     * - Get execution details:
     *
     *   Retrieves information about a specific execution.
     *
     *   ```yaml
     *   workflowExecutionId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowExecution
     */
    getWorkflowExecution: {
      name: "GetWorkflowExecution",
      I: GetWorkflowExecutionRequest,
      O: GetWorkflowExecutionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Cancels a running workflow execution.
     *
     * Use this method to:
     * - Stop long-running executions
     * - Cancel failed executions
     * - Manage resource usage
     *
     * ### Examples
     *
     * - Cancel execution:
     *
     *   Stops a running workflow execution.
     *
     *   ```yaml
     *   workflowExecutionId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.CancelWorkflowExecution
     */
    cancelWorkflowExecution: {
      name: "CancelWorkflowExecution",
      I: CancelWorkflowExecutionRequest,
      O: CancelWorkflowExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists workflow execution actions with optional filtering.
     *
     * Use this method to:
     * - Monitor individual action execution status
     * - Debug action failures
     * - Track resource usage per action
     *
     * ### Examples
     *
     * - List execution actions for workflow execution:
     *
     *   Shows all execution actions for a specific workflow execution.
     *
     *   ```yaml
     *   filter:
     *     workflowExecutionIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.ListWorkflowExecutionActions
     */
    listWorkflowExecutionActions: {
      name: "ListWorkflowExecutionActions",
      I: ListWorkflowExecutionActionsRequest,
      O: ListWorkflowExecutionActionsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific workflow execution action.
     *
     * Use this method to:
     * - Check execution action status
     * - View execution action results
     * - Monitor execution action progress
     *
     * ### Examples
     *
     * - Get execution action details:
     *
     *   Retrieves information about a specific execution action.
     *
     *   ```yaml
     *   workflowExecutionActionId: "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowExecutionAction
     */
    getWorkflowExecutionAction: {
      name: "GetWorkflowExecutionAction",
      I: GetWorkflowExecutionActionRequest,
      O: GetWorkflowExecutionActionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Cancels a running workflow execution action.
     *
     * Use this method to:
     * - Stop long-running actions
     * - Cancel failed actions
     * - Manage resource usage
     *
     * ### Examples
     *
     * - Cancel execution action:
     *
     *   Stops a running workflow execution action.
     *
     *   ```yaml
     *   workflowExecutionActionId: "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.CancelWorkflowExecutionAction
     */
    cancelWorkflowExecutionAction: {
      name: "CancelWorkflowExecutionAction",
      I: CancelWorkflowExecutionActionRequest,
      O: CancelWorkflowExecutionActionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the webhook secret for a workflow.
     *
     * This operation is audited for security purposes.
     *
     * Use this method to:
     * - Retrieve webhook secret for configuration
     * - Set up webhook integrations
     * - Verify webhook signatures
     *
     * ### Examples
     *
     * - Get webhook secret:
     *
     *   Retrieves the webhook secret for a workflow.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowWebhookSecret
     */
    getWorkflowWebhookSecret: {
      name: "GetWorkflowWebhookSecret",
      I: GetWorkflowWebhookSecretRequest,
      O: GetWorkflowWebhookSecretResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Rotates the webhook secret for a workflow.
     *
     * Use this method to:
     * - Generate a new webhook secret
     * - Invalidate the old webhook secret
     *
     * ### Examples
     *
     * - Rotate webhook secret:
     *
     *   Generates a new webhook secret for the workflow.
     *
     *   ```yaml
     *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WorkflowService.RotateWorkflowWebhookSecret
     */
    rotateWorkflowWebhookSecret: {
      name: "RotateWorkflowWebhookSecret",
      I: RotateWorkflowWebhookSecretRequest,
      O: RotateWorkflowWebhookSecretResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

